export default __webpack_public_path__ + "static/media/512-512-min.2b644b42.png";